import { Injectable, OnInit } from '@angular/core'
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http'
import { Observable } from 'rxjs'
import { AuthService } from '../services'

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService) { }

  getAccessToken(): string {
    return this.authService.getAuthToken()
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.getAccessToken()

    // Clone the request and add the Authorization header with the bearer token
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      })
      console.log("Bearer token added by interceptor: ", token)
    }
    // console.log(request)

    // Continue with the modified request
    return next.handle(request)
  }
}
